
// Core storage utilities and shared functions

// Prefix for all storage keys
export const PREFIX = 'ostomy-tracker-';

// Storage keys
export const KEYS = {
  USER: `${PREFIX}user`,
  PRODUCTS: `${PREFIX}products`,
  GROUPS: `${PREFIX}groups`,
  STOCK_UPDATES: `${PREFIX}stock-updates`,
  USAGE_RECORDS: `${PREFIX}usage-records`,
  ALERT_SETTINGS: `${PREFIX}alert-settings`,
};

// Generic get method with type safety
export const get = <T>(key: string): T[] => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : [];
};

// Generic set method
export const set = <T>(key: string, data: T[]): void => {
  localStorage.setItem(key, JSON.stringify(data));
};

// Helper to generate unique IDs (using proper UUID format for compatibility with Supabase)
export const generateId = (): string => {
  // Use the native crypto.randomUUID() for proper UUID generation
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  
  // Fallback for older browsers (should rarely be needed)
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, 
          v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
};
